export enum MaintenanceDashboardTabs {
  ACTIVE = "active",
  SCHEDULES = "schedules",
  EVENT_LOG = "event-log",
}
